// extracted by mini-css-extract-plugin
module.exports = {"cls1":"UserWorklistsPage-CssProp3_th-module--cls1--2dq3M","cls2":"UserWorklistsPage-CssProp3_th-module--cls2--dmOne UserWorklistsPage-CssProp3_th-module--cls1--2dq3M"};